import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { DynamicCountryFilter } from '../../dynamic-filter-inputs/dynamic-country-filter';
import { DynamicDateFilter } from '../../dynamic-filter-inputs/dynamic-date-filter';
import { DynamicSimpleSelectFilter } from '../../dynamic-filter-inputs/dynamic-simple-select-filter';
import { DynamicTextFilter } from '../../dynamic-filter-inputs/dynamic-text-filter';
import { DynamicPhoneNumberFilter } from '../../dynamic-filter-inputs/dynamic-phone-number-filter';
import { FIELD_TYPES } from '@shared/types/field';

import type { ReactNode } from 'react';
import type { TDynamicFilter } from '@shared/types/dynamic-filter';
import dynamicFilterApi from '@shared/features/views/services/dynamic-filter-api';

export type TDynamicFilterProps = {
  dynamicField?: unknown;
  values: string[];
  addOrEditDynamicFilter: (values: string[]) => void;
  onChange: (values: string[]) => void;
  options?: {
    label: string;
    value: string;
    [key: string]: string;
  }[];
};

type MapperType = Record<string, (props: TDynamicFilterProps) => ReactNode>;

const mapper: MapperType = {
  [FIELD_TYPES.shortAnswer]: DynamicTextFilter,
  [FIELD_TYPES.email]: DynamicTextFilter,
  [FIELD_TYPES.number]: DynamicTextFilter,
  [FIELD_TYPES.link]: DynamicTextFilter,
  [FIELD_TYPES.paragraph]: DynamicTextFilter,
  [FIELD_TYPES.date]: DynamicDateFilter,
  [FIELD_TYPES.country]: DynamicCountryFilter,
  [FIELD_TYPES.countryMultiselect]: DynamicCountryFilter,
  [FIELD_TYPES.dropdown]: DynamicSimpleSelectFilter,
  [FIELD_TYPES.checklist]: DynamicSimpleSelectFilter,
  [FIELD_TYPES.ratio]: DynamicSimpleSelectFilter,
  [FIELD_TYPES.phoneNumber]: DynamicPhoneNumberFilter,
};

export const DynamicFilterValueInput = ({
  dynamicField,
  index,
}: {
  dynamicField: TDynamicFilter;
  index: number;
}) => {
  const Field =
    mapper[dynamicField.field?.type as keyof typeof mapper] || DefaultFilter;
  const { mutate: editDynamicFilter } = dynamicFilterApi.useUpdate();
  const { mutate: createDynamicFilter } = dynamicFilterApi.useCreate();
  const { updateDynamicFilter } = useTableViewHelpers();

  const addOrEditDynamicFilter = (values: string[]) => {
    if (dynamicField?.id) {
      editDynamicFilter(
        {
          id: dynamicField.id,
          operator: dynamicField.operator,
          type: dynamicField.field?.type,
          field: dynamicField.field?.id,
          value: values,
        },
        {
          onSuccess: (data) => updateDynamicFilter(data, index),
        }
      );
    } else {
      createDynamicFilter(
        {
          operator: dynamicField.operator,
          type: dynamicField.field!.type,
          field: dynamicField.field!.id,
          value: values,
        },
        {
          onSuccess: (data) => updateDynamicFilter(data, index),
        }
      );
    }
  };

  return (
    <Field
      dynamicField={dynamicField.field}
      values={dynamicField.value || []}
      addOrEditDynamicFilter={addOrEditDynamicFilter}
      onChange={(values: string[]) =>
        updateDynamicFilter({ value: values }, index)
      }
      options={
        dynamicField.field?.options?.map((opt) => ({
          label: opt,
          value: opt,
        })) || []
      }
    />
  );
};

const DefaultFilter = () => {
  return <div>No Filter Found</div>;
};
